var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-sidebar",
        {
          ref: "sidebar",
          class: {
            "hide-text-on-reduce": !_vm.isHovered,
            locked: _vm.isMenuLocked,
          },
          attrs: {
            id: "mainSidebar",
            fullheight: "",
            type: "is-white",
            mobile: "fullwidth",
            "can-cancel": false,
            open: _vm.shouldSidebarBeOpen,
            "expand-on-hover": !_vm.isMenuLocked,
            reduce: !_vm.isMenuLocked,
          },
        },
        [
          _c("div", { staticClass: "creditu-logo-sidebar" }, [
            _c(
              "a",
              {
                on: {
                  click: () => {
                    _vm.$router.push({ name: "dashboard" })
                  },
                },
              },
              [
                _c("span", { staticClass: "iso" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/ui/assets/img/creditu-iso.svg"),
                      alt: "logo-creditu",
                    },
                  }),
                ]),
                _c("span", { staticClass: "logo-text" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/ui/assets/img/iso-text-creditu.svg"),
                      alt: "logo-creditu",
                    },
                  }),
                ]),
              ]
            ),
            _c("button", {
              class: {
                active: _vm.isMenuLocked,
                "menu-lock-hovered": _vm.isHovered,
              },
              attrs: { id: "menu-lock" },
              on: { click: _vm.toggleMenuLock },
            }),
          ]),
          _c(
            "b-menu",
            { staticClass: "is-custom-mobile" },
            [
              _c("b-menu-list", [
                _vm.getlistMenuOptions(undefined).length !== 0
                  ? _c(
                      "span",
                      _vm._l(
                        _vm.getlistMenuOptions(undefined),
                        function (item) {
                          return _c("b-menu-item", {
                            key: `
            ${item.name}-
            ${
              _vm.$store.state.currentUser &&
              _vm.$store.state.currentUser.user.checkIn &&
              _vm.$store.state.currentUser.user.checkIn.is
            }
            `,
                            attrs: {
                              id: `${item.route}-link`,
                              "data-cy": `${item.route}-link`,
                              icon: item.iconName,
                              label: item.name,
                              active: _vm.$route.path.includes(item.path),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleClick(item.route)
                              },
                            },
                          })
                        }
                      ),
                      1
                    )
                  : _vm._e(),
                _vm.getlistMenuOptions("consignments").length !== 0
                  ? _c(
                      "span",
                      [
                        _c(
                          "b-menu-item",
                          {
                            attrs: {
                              id: "consignments-parent-link",
                              icon: "hand-holding-usd",
                              label: _vm.$t("backOffice.finance"),
                              active: _vm.isAnyChildActive("consignments"),
                              expanded: _vm.isAnyChildActive("consignments"),
                            },
                          },
                          _vm._l(
                            _vm.getlistMenuOptions("consignments"),
                            function (item) {
                              return _c("b-menu-item", {
                                key: `
            ${item.name}-
            ${
              _vm.$store.state.currentUser &&
              _vm.$store.state.currentUser.user.checkIn &&
              _vm.$store.state.currentUser.user.checkIn.is
            }
            `,
                                attrs: {
                                  id: `${item.route}-link`,
                                  "data-cy": `${item.route}-link`,
                                  icon: item.iconName,
                                  label: item.name,
                                  active: _vm.$route.path.includes(item.path),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleClick(item.route)
                                  },
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.getlistMenuOptions("sales").length !== 0
                  ? _c(
                      "span",
                      [
                        _c(
                          "b-menu-item",
                          {
                            attrs: {
                              id: "sales-parent-link",
                              icon: "file-invoice-dollar",
                              label: _vm.$t("backOffice.sales"),
                              active: _vm.isAnyChildActive("sales"),
                              expanded: _vm.isAnyChildActive("sales"),
                            },
                          },
                          _vm._l(
                            _vm.getlistMenuOptions("sales"),
                            function (item) {
                              return _c("b-menu-item", {
                                key: `
            ${item.name}-
            ${
              _vm.$store.state.currentUser &&
              _vm.$store.state.currentUser.user.checkIn &&
              _vm.$store.state.currentUser.user.checkIn.is
            }
            `,
                                attrs: {
                                  id: `${item.route}-link`,
                                  "data-cy": `${item.route}-link`,
                                  icon: item.iconName,
                                  label: item.name,
                                  active: _vm.$route.path.includes(item.path),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleClick(item.route)
                                  },
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.getlistMenuOptions("investors").length !== 0
                  ? _c(
                      "span",
                      [
                        _c(
                          "b-menu-item",
                          {
                            attrs: {
                              id: "investors-parent-link",
                              icon: "briefcase",
                              label: _vm.$t("backOffice.investors"),
                              active: _vm.isAnyChildActive("investors"),
                              expanded: _vm.isAnyChildActive("investors"),
                            },
                          },
                          _vm._l(
                            _vm.getlistMenuOptions("investors"),
                            function (item) {
                              return _c("b-menu-item", {
                                key: `
            ${item.name}-
            ${
              _vm.$store.state.currentUser &&
              _vm.$store.state.currentUser.user.checkIn &&
              _vm.$store.state.currentUser.user.checkIn.is
            }
            `,
                                attrs: {
                                  id: `${item.route}-link`,
                                  "data-cy": `${item.route}-link`,
                                  icon: item.iconName,
                                  label: item.name,
                                  active: _vm.$route.path.includes(item.path),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleClick(item.route)
                                  },
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.getlistMenuOptions("primary-administration").length !== 0
                  ? _c(
                      "span",
                      [
                        _c(
                          "b-menu-item",
                          {
                            attrs: {
                              id: "primary-administration-parent-link",
                              icon: "table",
                              label: _vm.$t("backOffice.administration"),
                              active: _vm.isAnyChildActive(
                                "primary-administration"
                              ),
                              expanded: _vm.isAnyChildActive(
                                "primary-administration"
                              ),
                            },
                          },
                          _vm._l(
                            _vm.getlistMenuOptions("primary-administration"),
                            function (item) {
                              return _c("b-menu-item", {
                                key: `
            ${item.name}-
            ${
              _vm.$store.state.currentUser &&
              _vm.$store.state.currentUser.user.checkIn &&
              _vm.$store.state.currentUser.user.checkIn.is
            }
            `,
                                staticClass: "sub-menu-item",
                                attrs: {
                                  id: `${item.route}-link`,
                                  "data-cy": `${item.route}-link`,
                                  icon: item.iconName,
                                  label: item.name,
                                  active: _vm.$route.path.includes(item.path),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleClick(item.route)
                                  },
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm.screenWidth < 580
                ? _c(
                    "div",
                    { staticClass: "mt-6" },
                    [
                      _vm.getlistMenuOptions("header-menu").length !== 0
                        ? _c(
                            "b-menu-list",
                            _vm._l(
                              _vm.getlistMenuOptions("header-menu"),
                              function (item) {
                                return _c("b-menu-item", {
                                  key: `
            ${item.name}-
            ${
              _vm.$store.state.currentUser &&
              _vm.$store.state.currentUser.user.checkIn &&
              _vm.$store.state.currentUser.user.checkIn.is
            }
            `,
                                  attrs: {
                                    id: `${item.route}-link`,
                                    "data-cy": `${item.route}-link`,
                                    icon: item.iconName,
                                    label: item.name,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleClick(item.route)
                                    },
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "footer-selector" },
            [
              _vm.$store.state.currentUser &&
              (_vm.$store.state.currentUser.user.allowedFrontRoutesNames?.includes(
                "settings"
              ) ||
                _vm.$store.state.currentUser.user.allowedUserFeatures?.includes(
                  "nav.sidebar.settings"
                ))
                ? _c("b-button", {
                    attrs: {
                      id: "settings-link",
                      type: "is-primary is-light",
                      expanded: "",
                      "icon-left": "gear",
                    },
                    on: {
                      click: () => {
                        _vm.$router.push({ name: "settings" })
                        _vm.openMenuEmit()
                      },
                    },
                  })
                : _vm._e(),
              _vm.haveToShowCountryChange()
                ? _c(
                    "b-dropdown",
                    {
                      staticClass: "mt-0",
                      attrs: {
                        "aria-role": "list",
                        position: "is-top-right",
                        size: "sm",
                        "mobile-modal": false,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "trigger",
                            fn: function () {
                              return [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      id: "change-country",
                                      type: "is-primary is-light",
                                      "icon-left": "earth-america",
                                      expanded: "",
                                    },
                                  },
                                  [
                                    _vm.$i18n.locale === "cl"
                                      ? _c(
                                          "p",
                                          {
                                            staticClass: "lang-text",
                                            attrs: { id: "f-select-chile" },
                                          },
                                          [_vm._v("Chile")]
                                        )
                                      : _vm._e(),
                                    _vm.$i18n.locale === "br"
                                      ? _c(
                                          "p",
                                          {
                                            staticClass: "lang-text",
                                            attrs: { id: "f-select-brasil" },
                                          },
                                          [_vm._v("Brasil")]
                                        )
                                      : _vm._e(),
                                    _vm.$i18n.locale === "pe"
                                      ? _c(
                                          "p",
                                          {
                                            staticClass: "lang-text",
                                            attrs: { id: "f-select-peru" },
                                          },
                                          [_vm._v("Perú")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1015970607
                      ),
                    },
                    [
                      _vm.allowCountryForChange("br")
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                id: "f-select-brasil",
                                "mobile-modal": "false",
                                "aria-role": "listitem",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeCountry("br")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "fas fa-2 ml-7 img-country country",
                                attrs: {
                                  src: require("@/ui/assets/img/brasil.png"),
                                },
                              }),
                              _c("span", { staticClass: "ml-1 country" }, [
                                _vm._v("Brasil"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.allowCountryForChange("cl")
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                id: "f-select-chile",
                                "mobile-modal": "false",
                                "aria-role": "listitem",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeCountry("cl")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "fas fa-2 ml-7 img-country country",
                                attrs: {
                                  src: require("@/ui/assets/img/chile.png"),
                                },
                              }),
                              _c("span", { staticClass: "ml-1 country" }, [
                                _vm._v("Chile"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.allowCountryForChange("pe")
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                id: "f-select-peru",
                                "mobile-modal": "false",
                                "aria-role": "listitem",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeCountry("pe")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "fas fa-2 ml-7 img-country country",
                                attrs: {
                                  src: require("@/ui/assets/img/peru.png"),
                                },
                              }),
                              _c("span", { staticClass: "ml-1 country" }, [
                                _vm._v("Perú"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { scroll: "keep" },
          model: {
            value: _vm.isTrustedIdNumbersCardModalActive,
            callback: function ($$v) {
              _vm.isTrustedIdNumbersCardModalActive = $$v
            },
            expression: "isTrustedIdNumbersCardModalActive",
          },
        },
        [
          _c("trusted-id-numbers", {
            on: {
              "is-modal-active": function ($event) {
                _vm.isTrustedIdNumbersCardModalActive = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }